document.addEventListener('DOMContentLoaded', function() {
  let sendNow = document.getElementById("sendNow");
  let sendLater = document.getElementById("sendLater");
  let deliveryDate = document.getElementById("delivery_date");
  if (!deliveryDate) return;

  let deliverySelector = deliveryDate.querySelector("input");

  let storeCurrent = deliverySelector.getAttribute("name");

  deliverySelector.removeAttribute("name");

  if (sendLater) {
    sendLater.addEventListener("click", function() {
      deliveryDate.classList.remove("hidden");
      deliverySelector.required = true;

      if (deliverySelector.getAttribute("name") == null) {
        deliverySelector.setAttribute("name", storeCurrent);
      }
    });
  }

  if (sendNow) {
    sendNow.addEventListener("click", function() {
      deliveryDate.classList.add("hidden");
      deliverySelector.removeAttribute("name");
      deliverySelector.required = false;
    });
  }

  let allOptions = document.querySelectorAll(".c-gift-options__option");
  let select = document.getElementById("SingleOptionSelector-0");

  if (allOptions) {
    allOptions.forEach((option) => {
      option.addEventListener("click", function() {
        let currentOption = option.dataset.option;
  
        toggleOptionClasses(option);
  
        select.value = currentOption;
        select.dispatchEvent(new Event("change"));
      });
    }); 
  }

  if (select) {
    select.addEventListener("change", function() {
      let selectedValue = select.value;
      let option = document.getElementById("gift-option-" + selectedValue);
      toggleOptionClasses(option);
    }); 
  }

  function toggleOptionClasses(option) {
    $(".c-gift-options__option").removeClass("is-selected");
    option.classList.add("is-selected");
  }
});
